import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PROGRAMS } from "../data/content";
import ClientTicker from "../components/sections/ClientTicker";
import ContactSplit from "../components/sections/ContactSplit";
import { MaskedLine, MaskedLineInView } from "../components/MaskedLine";

const GROUNDS = ["ground-paper", "ground-margin", "ground-lab", "ground-highlighter", "ground-paper", "ground-margin", "ground-lab", "ground-highlighter"];

export default function ProgramsPage() {
  return (
    <main data-testid="page-programs">
      <section className="ground-paper pt-[104px] pb-14 md:pt-[132px] md:pb-20 md:pb-32">
        <div className="wrap">
          <div className="flex items-center gap-4 mb-12">
            <span className="series-stamp"><span>Index · Programs</span></span>
            <span className="stamp-dim">3 papers · 1 idea</span>
          </div>
          <h1 className="h-hero max-w-[1200px]" style={{ fontSize: "clamp(56px, 9vw, 156px)" }}>
            <MaskedLine>Eight capabilities.</MaskedLine>
            <MaskedLine delay={0.12}><span className="claim">One professional.</span></MaskedLine>
          </h1>
          <p className="aside mt-10 max-w-[640px]">
            Every program is experiential. Seventy per cent practice. Thirty per cent framework. Designed for organisations that need behaviour change, not certificates of completion.
          </p>
        </div>
      </section>

      <ClientTicker />

      <section className="ground-paper sec-pad">
        <div className="wrap border-t-[1.5px] border-[color:var(--ink)] grid grid-cols-1 md:grid-cols-2">
          {PROGRAMS.map((p, i) => (
            <Link
              key={p.slug}
              to={`/programs/${p.slug}`}
              data-testid={`programs-page-card-${p.slug}`}
              className={`${GROUNDS[i]} group p-8 md:p-12 border-b-[1.5px] border-[color:var(--ink)] ${i % 2 === 1 ? "md:border-l-[1.5px]" : ""}`}
            >
              <div className="flex items-start justify-between">
                <span className="stamp">Program {p.number}</span>
                <ArrowUpRight size={22} className="text-[#0E1330] transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
              <div className="frame aspect-[16/10] mt-10">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover" loading="lazy" />
              </div>
              <h2 className="h-tile mt-10" style={{ fontSize: "clamp(28px, 3vw, 40px)" }}>
                <MaskedLineInView>{p.title}</MaskedLineInView>
              </h2>
              <p className="aside mt-6 text-[19px]">{p.tagline}</p>
            </Link>
          ))}
        </div>
      </section>

      <ContactSplit />
    </main>
  );
}
